import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const SimposPage = () => (
  <Layout>
  <div className="masthead-followup row m-0 bg-white border border-white text-center">
	  <div className="col-12 col-md-12 p-12 p-3 p-md-5 bg-white border border-white text-dark text-center">
    <Seo title="APLIKASI KASIR ANDROID IPHONE SIMPLE POS" />
    <h2><strong>SIMPLE POS</strong></h2>
		  <div className="embed-responsive embed-responsive-21by9">
<iframe title="aplikasi kasir simple hockey pos" width="560" height="315" src="https://www.youtube.com/embed/rNaH_gmcDDo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
    <p>
Kompleks simple dan tentu sangat mudah digunakan dengan display modern era <a href="/simpos" title="aplikasi kasir online">aplikasi kasir online</a> saat ini semakin lebih baik digunakan baik offline mode maupun online mode yang memungkinkan untuk akses via smartphone mu langsung real time online.
Fitur master based user dengan password , supplier , dan produk support barcode kode , transaksi pembelian , transaksi penjualan point of sale kasir pada mesin kasir, metode cetak struk kasir atau A4 letter faktur jual , laporan laporan detail mulai stok dan omset profit usaha tersedia pada aplikasi kasir online ini, khsusus kebutuhan offline dengan mesin kasir singgle standalone adalah solusi murah untuk pembukuan usaha mu.</p>
<a href="https://mesinkasir.github.io/e-catalog/hockeysimple%20pos.pdf" target="blank" className="button" title="download Simple pos">Download</a>
<p>Download e-Catalog untuk cek harga dan pilihan paket.</p>
<Link to="/hockeypos" className="button button-outline float-left" title="aplikasi kasir online hockeypos">&larr; HockeyPOS</Link> <Link to="/ipos" className="button button-outline float-right" title="Invoice Of POS">IPOS &rarr;</Link>
</div>

 
	</div>
  </Layout>
)

export default SimposPage